// // store/modules/storification.js
import Vue from 'vue';

export default {
    namespaced: false,
    state: {
        storification: {
            backgroundColor: null,
            link: null,
            texts: [],
            textsReel: [],
            layers: [],
            gifs: [],
            gifsReel: [],
            mentions: [],
            hashtags: [],
            location: null,
            product: null,
            music: null,
            musicReel: null,
            poll: null,
            slider: null,
            template: null,
            hightlight: null,
            screenshot: null,
            question: null,
        },
        emittedObject: null,
    },
    mutations: {

        /// Data To Emit ///

        updateData(state, object) {
            if (!object) state.emittedObject = null
            else {
                if (!state.emittedObject) state.emittedObject = {}
                state.emittedObject.message = object.message; 
                state.emittedObject.data = object.data; 
            }
        },

        /// Storification ///

        updateStorification(state, data) {
            console.log("updateStorification", data);
            if (data && data.backgroundColor === '#000000') {
                data.backgroundColor = null;
            }
            state.storification = data;
        },

        updateStorificationLink(state, newLink) {
            console.log("updateStorificationLink", newLink);
            if(!state.storification) state.storification = {}
            state.storification.link = newLink && state && state.storification ? {...state.storification.link, ...newLink} : null;
        },

        updateStorificationBackgroundColor(state, newColor) {
            console.log("updateStorificationBackgroundColor", newColor);
            if(!state.storification) state.storification = {}
            state.storification.backgroundColor = newColor;
        },

        updateStorificationTexts(state, newTexts) {
            if(!state.storification) state.storification = {}
            state.storification.texts = newTexts;
        },

        updateStorificationText(state, newText) {
            let index = newText.index;
            console.log(newText, index);
            if (index != null) {
                index = parseInt(index);
                if(!state.storification) state.storification = {}
                if(!state.storification.texts) state.storification.texts = []
                delete newText.index;
                Vue.set(state.storification.texts, index, {...state.storification.texts[index], ...newText})
                // state.storification.texts[index] =  {...state.storification.texts[index], ...newText};
            }
        },

        addStorificationText(state, newText) {
            if(!state.storification) state.storification = {}
            if(!state.storification.texts) state.storification.texts = []
            if (state.storification.texts.filter(e => e.content !== '').length === 0) state.storification.texts = []
            state.storification.texts.push(newText);
        },

        removeStorificationText(state, index) {
            if(!state.storification) state.storification = {}
            if(!state.storification.texts) state.storification.texts = []
            state.storification.texts.splice(index, 1);
        },



        updateStorificationTextsReel(state, newTexts) {
            if(!state.storification) state.storification = {}
            state.storification.textsReel = newTexts;
        },

        updateStorificationTextReel(state, newText) {
            let index = newText.index;
            console.log(newText, index);
            if (index != null) {
                index = parseInt(index);
                if(!state.storification) state.storification = {}
                if(!state.storification.textsReel) state.storification.textsReel = []
                delete newText.index;
                Vue.set(state.storification.textsReel, index, {...state.storification.textsReel[index], ...newText})
                // state.storification.texts[index] =  {...state.storification.texts[index], ...newText};
            }
        },

        addStorificationTextReel(state, newText) {
            if(!state.storification) state.storification = {}
            if(!state.storification.textsReel) state.storification.textsReel = []
            if (state.storification.textsReel.filter(e => e.content !== '').length === 0) state.storification.textsReel = []
            state.storification.textsReel.push(newText);
        },

        removeStorificationTextReel(state, index) {
            if(!state.storification) state.storification = {}
            if(!state.storification.textsReel) state.storification.textsReel = []
            state.storification.textsReel.splice(index, 1);
        },



        addStorificationLayer(state, newLayer) {
            if(!state.storification) state.storification = {}
            if(!state.storification.layers) state.storification.layers = []
            state.storification.layers.push(newLayer);
        },

        removeStorificationLayer(state, index) {
            if(!state.storification) state.storification = {}
            if(!state.storification.layers) state.storification.layers = []
            state.storification.layers.splice(index, 1);
        },

        updateStorificationLayers(state, newLayers) {
            if(!state.storification) state.storification = {}
            state.storification.layers = newLayers;
        },

        updateStorificationLayer(state, newLayer) {
            let index = newLayer.index;
            if (index != null) {
                index = parseInt(index);
                if(!state.storification) state.storification = {}
                if(!state.storification.layers) state.storification.layers = []
                delete newLayer.index;
                Vue.set(state.storification.layers, index, {...state.storification.layers[index], ...newLayer})
            }
        },

        addStorificationGif(state, newGif) {
            if(!state.storification) state.storification = {}
            if(!state.storification.gifs) state.storification.gifs = []
            state.storification.gifs.push(newGif);
            if (state.storification.layers && state.storification.layers.length) {
                this.commit('updateStorificationLayers', []);
            }
        },

        removeStorificationGif(state, index) {
            if(!state.storification) state.storification = {}
            if(!state.storification.gifs) state.storification.gifs = []
            state.storification.gifs.splice(index, 1);
        },

        updateStorificationGifs(state, newGifs) {
            if(!state.storification) state.storification = {}
            state.storification.gifs = newGifs;
        },

        updateStorificationGif(state, newGif) {
            let index = newGif.index;
            if (index != null) {
                index = parseInt(index);
                if(!state.storification) state.storification = {}
                if(!state.storification.gifs) state.storification.gifs = []
                delete newGif.index;
                Vue.set(state.storification.gifs, index, {...state.storification.gifs[index], ...newGif})
            }
        },



        addStorificationGifReel(state, newGif) {
            if(!state.storification) state.storification = {}
            if(!state.storification.gifsReel) state.storification.gifsReel = []
            state.storification.gifsReel.push(newGif);
            // if (state.storification.layers && state.storification.layers.length) {
            //     this.commit('updateStorificationLayers', []);
            // }
        },

        removeStorificationGifReel(state, index) {
            if(!state.storification) state.storification = {}
            if(!state.storification.gifsReel) state.storification.gifsReel = []
            state.storification.gifsReel.splice(index, 1);
        },

        updateStorificationGifsReel(state, newGifs) {
            if(!state.storification) state.storification = {}
            state.storification.gifsReel = newGifs;
        },

        updateStorificationGifReel(state, newGif) {
            let index = newGif.index;
            if (index != null) {
                index = parseInt(index);
                if(!state.storification) state.storification = {}
                if(!state.storification.gifsReel) state.storification.gifsReel = []
                delete newGif.index;
                Vue.set(state.storification.gifsReel, index, {...state.storification.gifsReel[index], ...newGif})
            }
        },

        updateStorificationProduct(state, newProduct) {
            if(!state.storification) state.storification = {}
            state.storification.product =  newProduct && state && state.storification ? {...state.storification.product, ...newProduct} : null;
            
        },

        removeStorificationProduct(state) {
            if(!state.storification) state.storification = {}
            state.storification.product = null;
        },

        removeStorificationProductItem(state, index) {
            if(!state.storification) state.storification = {}
            if(!state.storification.product) state.storification.product = {}
            if(!state.storification.product.items) state.storification.product.items = []
            state.storification.product.items.splice(index, 1);
        },


        updateStorificationMusic(state, newMusic) {
            if(!state.storification) state.storification = {}
            state.storification.music =  newMusic && state && state.storification ? {...state.storification.music, ...newMusic} : null;
            if (state.storification.layers && state.storification.layers.length) {
                this.commit('updateStorificationLayers', []);
            }
        },

        removeStorificationMusic(state) {
            if(!state.storification) state.storification = {}
            state.storification.music = null;
        },

        updateStorificationMusicReel(state, newMusic) {
            if(!state.storification) state.storification = {}
            state.storification.musicReel =  newMusic && state && state.storification ? {...state.storification.musicReel, ...newMusic} : null;
            // if (state.storification.layers && state.storification.layers.length) {
            //     this.commit('updateStorificationLayers', []);
            // }
        },

        removeStorificationMusicReel(state) {
            if(!state.storification) state.storification = {}
            state.storification.musicReel = null;
        },

        updateStorificationLocation(state, newLocation) {
            if(!state.storification) state.storification = {}
            state.storification.location =  newLocation && state && state.storification ? {...state.storification.location, ...newLocation} : null;
            
        },

        removeStorificationLocation(state) {
            if(!state.storification) state.storification = {}
            state.storification.location = null;
        },

        updateStorificationPoll(state, newPoll) {
            if(!state.storification) state.storification = {}
            state.storification.poll =  newPoll && state && state.storification ? {...state.storification.poll, ...newPoll} : null;
        },

        updateStorificationPollOption(state, newPoll) {
            let index = newPoll.index;
            console.log(newPoll);
            if (index != null) {
                Vue.set(state.storification.poll.options, index, newPoll.option);
            }
        },

        removeStorificationPoll(state) {
            if(!state.storification) state.storification = {}
            state.storification.poll = null;
        },

        updateStorificationSlider(state, newSlider) {
            if(!state.storification) state.storification = {}
            state.storification.slider =  newSlider && state && state.storification ? {...state.storification.slider, ...newSlider} : null;
        },

        removeStorificationSlider(state) {
            if(!state.storification) state.storification = {}
            state.storification.slider = null;
        },

        updateStorificationMentions(state, newMentions) {
            if(!state.storification) state.storification = {}
            state.storification.mentions = newMentions;
        },

        addStorificationMention(state, newMention) {
            if(!state.storification) state.storification = {}
            if(!state.storification.mentions) state.storification.mentions = []
            state.storification.mentions.push(newMention);
        },

        removeStorificationMention(state, index) {
            if(!state.storification) state.storification = {}
            if(!state.storification.mentions) state.storification.mentions = []
            state.storification.mentions.splice(index, 1);
        },

        updateStorificationMention(state, newMention) {
            let index = newMention.index;
            if (index != null) {
                index = parseInt(index);
                if(!state.storification) state.storification = {}
                if(!state.storification.mentions) state.storification.mentions = []
                delete newMention.index;
                Vue.set(state.storification.mentions, index, {...state.storification.mentions[index], ...newMention})
            }
        },

        removeStorificationHashtag(state, index) {
            if(!state.storification) state.storification = {}
            if(!state.storification.hashtags) state.storification.hashtags = []
            state.storification.hashtags.splice(index, 1);
        },

        addStorificationHashtag(state, newHashtagArray) {
            console.log(newHashtagArray);
            if(!state.storification) state.storification = {}
            if(!state.storification.hashtags) state.storification.hashtags = []
            if (newHashtagArray && Array.isArray(newHashtagArray)) {
                console.log("ici");
                for (let tag of newHashtagArray) {
                    state.storification.hashtags.push(tag);
                }
                // state.storification.hashtags.concat(newHashtagArray);
            } else if (newHashtagArray) {
                console.log("la");
                state.storification.hashtags.push(newHashtagArray);
            }
        },

        updateStorificationHashtags(state, newHashtags) {
            if(!state.storification) state.storification = {}
            state.storification.hashtags = newHashtags;
        },

        updateStorificationHashtag(state, newHashtag) {
            let index = newHashtag.index;
            if (index != null) {
                index = parseInt(index);
                if(!state.storification) state.storification = {}
                if(!state.storification.hashtags) state.storification.hashtags = []
                delete newHashtag.index;
                Vue.set(state.storification.hashtags, index, {...state.storification.hashtags[index], ...newHashtag})
            }
        },

        updateStorificationTemplate(state, newTemplate) {
            console.log("updateStorificationTemplate", newTemplate, typeof newTemplate);
            if(!state.storification) state.storification = {}
            state.storification.template = newTemplate;
        },

        removeStorificationTemplate(state) {
            if(!state.storification) state.storification = {}
            state.storification.template = null;
        },

        updateStorificationHightlight(state, newHightlight) {
            if(!state.storification) state.storification = {}
            state.storification.hightlight = newHightlight;
        },

        removeStorificationHightlight(state) {
            if(!state.storification) state.storification = {}
            state.storification.hightlight = null;
        },

        removeStorificationLink(state) {
            if(!state.storification) state.storification = {}
            state.storification.link = null;
            this.dispatch("emitData", {message: "removeLink"});
        },

        updateStorificationScreenshot(state, newScreenshot) {
            if(!state.storification) state.storification = {}
            state.storification.screenshot = newScreenshot;
        },

        updateStorificationQuestion(state, newQuestion) {
            if(!state.storification) state.storification = {}
            state.storification.question = newQuestion && state && state.storification ? {...state.storification.question, ...newQuestion} : null;
        }

    },
    actions: {
        resetStorification() {
            console.log("reset");
            this.commit('updateStorificationLink', null);
            this.commit('updateStorificationBackgroundColor', null);
            this.commit('updateStorificationTexts', []);
            this.commit('updateStorificationLayers', []);
            this.commit('updateStorificationGifs', []);
            this.commit('updateStorificationMusic', null);
            this.commit('updateStorificationPoll', null);
            this.commit('updateStorificationSlider', null);
            this.commit('updateStorificationMentions', []);
            this.commit('updateStorificationHashtags', []);
            this.commit('updateStorificationTemplate', null);
            this.commit('updateStorificationHightlight', null);
            this.commit('updateStorificationScreenshot', null);
            this.commit('updateStorificationLocation', null);
            this.commit('updateStorificationProduct', null);
            this.commit('updateStorificationTextsReel', []);
            this.commit('updateStorificationMusicReel', null);
            this.commit('updateStorificationGifsReel', []);
            this.commit('updateStorificationQuestion', null);
        },

        emitData(_, {message, data}) {
            console.log("emitData", message, data);
            this.commit('updateData', {message, data});
            setTimeout(() => {
                this.commit('updateData', null);
            }, 100)

        },

        addStorificationTextDefault(_, newTextContent='') {
            let newText = {
                content: newTextContent,
                visible: true,
                font: 1,
                color: 'white',
                size: 20,
                background: 0,
                // rotation: 0,
            }
            this.commit('addStorificationText', newText);
        },

        addStorificationTextDefaultReel(_, newTextContent='') {
            let newText = {
                content: newTextContent,
                visible: true,
                font: 1,
                color: 'white',
                size: 20,
                background: 0,
                // rotation: 0,
            }
            this.commit('addStorificationTextReel', newText);
        },

        addStorificationLayerDefault(_, file) {
            console.log("addStorificationLayerDefault",file);
            let reader = new FileReader();
            reader.onload = (e) => {
                let image = new Image();
                image.src = e.target.result;
                image.onload = () => {
                    let newLayer = {
                        reader: e.target.result,
                        file,
                        x: 0, 
                        y: 0,
                        color: 0,
                        w: image.width,
                        h: image.height,
                    }
                    console.log(newLayer);
                    this.commit('addStorificationLayer', newLayer);
                };
            };
            reader.readAsDataURL(file);
            
        },

    },
    getters: {
        /// Data To Emit ///
        emittedObject(state) {
            return state.emittedObject;
        },

        /// Storification ///
        storification(state) { 
            let storification = JSON.parse(JSON.stringify(state.storification))
            if (storification && storification.poll) {
                if (!storification.poll.question)  storification.poll.question =  "";
                if (!storification.poll.options[0]) storification.poll.options[0] = "OUI";
                if (!storification.poll.options[1]) storification.poll.options[1] = "NON";
            }
            if (storification && storification.slider) {
                if (!storification.slider.question)  storification.slider.question = "";
                if (!storification.slider.emoji) storification.slider.emoji = "😍";
                if (!storification.slider.color) storification.slider.color = 0;
            }
            if (storification && storification.product) {
                storification.product.items = storification.product.items.map(e => {
                    return {text: e.text, id: e.id, merchantId: e.merchantId}
                })
            }
            return {...storification};
        },

        storificationLinkIsActive(state) {
            return state.storification && state.storification.link && state.storification.link.active;
        },

        storificationLinkText(state) {
            return state.storification && state.storification.link && state.storification.link.text ? state.storification.link.text : '';
        },

        storificationLink(state) {
            if (!state.storification || !state.storification.link) return null;
            if (state.storification.link && !state.storification.link.active) return null;
            if (Object.keys(state.storification.link).length === 1 && Object.hasOwn(state.storification.link, 'active')) return null;
            return {...state.storification.link};
        },
        
        storificationBackgroundColor(state) {
            return state.storification && state.storification.backgroundColor ? state.storification.backgroundColor : null;
        },

        storificationTexts(state) {
            if (!state.storification || !state.storification.texts) return [];
            // return [...state.storification.texts]
            return state.storification.texts.map(e => {
                if (!e.visible) {
                    return {
                        ...e,
                        x: -100,
                        y: -100
                    }
                }
                return e;
            })
        },

        storificationTextUniq(state) {
            return function (index) {
                if (!state.storification || !state.storification.texts) return null;
                if (!state.storification.texts[index].visible) {
                    return {
                        ...state.storification.texts[index],
                        x: -100,
                        y: -100
                    }
                }
                return {...state.storification.texts[index]};
            }
        },

        storificationTextProperty(state) {
            return function (index, property) {
                if (!state.storification || !state.storification.texts) return null;
                if (!state.storification.texts[index].visible && ['x', 'y'].includes(property)) {
                    return -100;
                }
                return state.storification.texts[index][property];
            }
        },

        storificationTextsReel(state) {
            if (!state.storification || !state.storification.textsReel) return [];
            // return [...state.storification.texts]
            return state.storification.textsReel.map(e => {
                if (!e.visible) {
                    return {
                        ...e,
                        x: -100,
                        y: -100
                    }
                }
                return e;
            })
        },

        storificationTextUniqReel(state) {
            return function (index) {
                if (!state.storification || !state.storification.textsReel) return null;
                if (!state.storification.textsReel[index].visible) {
                    return {
                        ...state.storification.textsReel[index],
                        x: -100,
                        y: -100
                    }
                }
                return {...state.storification.textsReel[index]};
            }
        },

        storificationTextPropertyReel(state) {
            return function (index, property) {
                if (!state.storification || !state.storification.textsReel) return null;
                if (!state.storification.textsReel[index].visible && ['x', 'y'].includes(property)) {
                    return -100;
                }
                return state.storification.textsReel[index][property];
            }
        },

        storificationLayers(state) {
            if (!state.storification || !state.storification.layers) return [];
            return [...state.storification.layers]
        },

        storificationLayersFormated(state) {
            if (!state.storification || !state.storification.layers) return [];
            return [...state.storification.layers].map(e => {
                return {...e, x: e.x * 3, y: e.y * 3, w: e.w * 3, h: e.h * 3};
            })
        },

        storificationGifs(state) {
            if (!state.storification || !state.storification.gifs) return [];
            return [...state.storification.gifs]
        },

        storificationGifsFormated(state) {
            if (!state.storification || !state.storification.gifs) return [];
            return [...state.storification.gifs].map(e => {
                return {...e, x: e.x * 3, y: e.y * 3, w: e.w * 3, h: e.h * 3};
            })
        },

        storificationGifsReel(state) {
            if (!state.storification || !state.storification.gifsReel) return [];
            return [...state.storification.gifsReel]
        },

        storificationGifsFormatedReel(state) {
            if (!state.storification || !state.storification.gifsReel) return [];
            return [...state.storification.gifsReel].map(e => {
                return {...e, x: e.x * 3, y: e.y * 3, w: e.w * 3, h: e.h * 3};
            })
        },

        storificationProduct(state) {
            return state.storification && state.storification.product ? {...state.storification.product} : null;
        },

        storificationProductWithoutImage(state) {
            if (!state.storification || !state.storification.product) return null;
            let newProduct = JSON.parse(JSON.stringify(state.storification.product));
            newProduct.items = newProduct.items.map(e => {
                return {text: e.text, id: e.id, merchantId: e.merchantId}
            })
            return newProduct;
        },

        storificationMusic(state) {
            return state.storification && state.storification.music ? {...state.storification.music, end: state.storification.music.start + (state.storification.music.duration || 15000), startTime: state.storification.music.start} : null;
        },

        storificationMusicReel(state) {
            return state.storification && state.storification.musicReel ? {...state.storification.musicReel, end: state.storification.musicReel.start + (state.storification.musicReel.duration || 15000), startTime: state.storification.musicReel.start} : null;
        },

        storificationLocation(state) {
            return state.storification && state.storification.location ? {...state.storification.location} : null;
        },

        storificationPoll(state) {
            return state.storification && state.storification.poll ? {...state.storification.poll} : null;
        },

        storificationSlider(state) {
            return state.storification && state.storification.slider ? {...state.storification.slider} : null;
        },

        storificationMentions(state) {
            if (!state.storification || !state.storification.mentions) return [];
            return [...state.storification.mentions]
        },

        storificationMentionsFormated(state) {
            if (!state.storification || !state.storification.mentions) return [];
            return [...state.storification.mentions].map(e => {
                return {...e, x: e.x * 3, y: e.y * 3, w: e.w * 3, h: e.h * 3};
            })
        },

        storificationHashtags(state) {
            if (!state.storification || !state.storification.hashtags) return [];
            return [...state.storification.hashtags]
        },

        storificationHashtagsFormated(state) {
            if (!state.storification || !state.storification.hashtags) return [];
            return [...state.storification.hashtags].map(e => {
                return {...e, x: e.x * 3, y: e.y * 3, w: e.w * 3, h: e.h * 3};
            })
        },
        

        storificationTemplate(state) {
            return state.storification ? state.storification.template : null;
        },

        storificationHightlight(state) {
            return state.storification ? state.storification.hightlight : null;
        },

        storificationScreenshot(state) {
            return state.storification ? state.storification.screenshot : null;

        },

        storificationQuestion(state) {
            return state.storification && state.storification.question ? {...state.storification.question} : null;
        }

    }
};